import React from 'react';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import styles from '../styles/ModeLoadingContent.module.css';

export interface ModeLoadingContentProps {
  /** Loading message to display below the spinner */
  message: string;
}

/**
 * Shared loading content component for mode content areas.
 * Displays a centered spinner with a message.
 * Used by Suggestion Mode and FSQ Mode during data loading.
 */
export const ModeLoadingContent: React.FC<ModeLoadingContentProps> = ({ message }) => {
  return (
    <div className={styles.container}>
      <AutorenewIcon className={styles.spinner} />
      <p className={styles.message}>{message}</p>
    </div>
  );
};

export default ModeLoadingContent;
